import React from 'react';
import { FaLinkedinIn } from 'react-icons/fa';

// into TeamOne
let teamCore = [
  {
    images: '01',
    name: 'Syed Muhammad Abbas',
    title: 'Financial & Economic Forecaster',
    SocialNetworkIcon: <FaLinkedinIn />,
    facebook: 'https://www.facebook.com',
    linkedin: 'https://www.linkedin.com/in/sajjad-sardar/',
    twitter: 'https://www.twitter.com',
  },
  {
    images: '02',
    name: 'Irtaza Ali',
    title: 'Entrepreneurship',
    SocialNetworkIcon: <FaLinkedinIn />,
    facebook: 'https://www.facebook.com/profile.php?id=658478741',
    linkedin: 'https://www.linkedin.com',
    twitter: 'https://www.twitter.com',
  },
  {
    images: '03',
    name: 'Musa Raza',
    title: 'UAV & RS Technology',
    SocialNetworkIcon: <FaLinkedinIn />,
    facebook: 'https://www.facebook.com',
    linkedin: 'https://www.linkedin.com',
    twitter: 'https://www.twitter.com',
  },
  {
    images: '04',
    name: 'Dr Najm Abbas',
    title: 'GNSS, GIS & SLF (Consultant)',
    // designation:
    //   'A business executive with experience in Economics and Business Management having expertise in Business Mapping and Ergonomics',
    SocialNetworkIcon: <FaLinkedinIn />,
    facebook: 'https://www.facebook.com/abbas.syed.18007',
    linkedin: 'https://www.linkedin.com',
    twitter: 'https://www.twitter.com',
    // socialNetwork: [
    //   {
    //     Icon: <FaFacebookF />,
    //     url: "#",
    //   },
    //   {
    //     Icon: <FaLinkedinIn />,
    //     url: "#",
    //   },
    //   {
    //     Icon: <FaTwitter />,
    //     url: "#",
    //   },
    // ],
  },
  {
    images: '05',
    name: 'Maryum Khan',
    title: 'GIS Specialist & Analyst',
    SocialNetworkIcon: <FaLinkedinIn />,
    facebook: 'https://www.facebook.com/abbas.syed.18007',
    linkedin: 'https://www.linkedin.com',
    twitter: 'https://www.twitter.com',
  },
];

// into TeamTwo
export const advisors = [
  {
    images: '01',
    name: 'Dr Ghulam Mehdi ',
    title: 'ML, DL & AI Expert Data Scientist',
    SocialNetworkIcon: <FaLinkedinIn />,
    facebook: 'https://www.facebook.com',
    linkedin: 'https://www.linkedin.com/in/yarjan-abdul-samad-9ba8275/',
    twitter: 'https://www.twitter.com',
  },
  {
    images: '02',
    name: 'Dr Ali Raza',
    title: 'Machine Learning Software Dev',
    SocialNetworkIcon: <FaLinkedinIn />,
    facebook: 'https://www.facebook.com',
    linkedin: 'https://www.linkedin.com/in/syed-ali-raza-zaidi-86a65213/',
    twitter: 'https://www.twitter.com',
  },
  {
    images: '03',
    name: 'Dr Haider Abbas',
    title: 'Certified Crop Scientist (Consultant)',
    SocialNetworkIcon: <FaLinkedinIn />,
    facebook: 'https://www.facebook.com/najam.abbas.naqvi',
    linkedin: 'https://www.linkedin.com/in/najmnaqvi/',
    twitter: 'https://www.twitter.com',
  },
  {
    images: '04',
    name: 'Dr Shahid Afghan',
    title: 'Chief Agronomist',
    SocialNetworkIcon: <FaLinkedinIn />,
    facebook: 'https://www.facebook.com',
    linkedin: 'https://www.linkedin.com/in/jamil-kazmi-53873915/',
    twitter: 'https://www.twitter.com',
  },
  {
    images: '01',
    name: 'Saad Aslam',
    title: 'Operational Management',
    SocialNetworkIcon: <FaLinkedinIn />,
    facebook: 'https://www.facebook.com',
    linkedin: 'https://www.linkedin.com/in/ghulam-mahdi-phd-a927007/',
    twitter: 'https://www.twitter.com',
    // socialNetwork: [
    //   {
    //     Icon: <FaFacebookF />,
    //     url: "#",
    //   },
    //   {
    //     Icon: <FaLinkedinIn />,
    //     url: "#",
    //   },
    //   {
    //     Icon: <FaTwitter />,
    //     url: "#",
    //   },
    // ],
  },
];

// into TeamOne
export default teamCore;
